var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGiftBag = function SvgGiftBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.854 14h26.292v11.955A4.045 4.045 0 0 1 24.101 30H5.9a4.045 4.045 0 0 1-4.045-4.045V14Z",
    fill: "#5A35BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.006 0c2.746 0 6.021 4.84 6.021 7.432 0 2.12-2.193 2.079-4.494 1.994L9.15 9.41a31.813 31.813 0 0 0-1.143-.026c-2.746 0-4.972-2.1-4.972-4.692S5.26 0 8.006 0Zm-.23 3.68c-1.501 0-2.709.747-2.709 1.904S8.476 7.32 10.43 7.32c.674 0 .908-.581 1.003-.946.146-.874-2.157-2.693-3.658-2.693ZM21.864 0c-2.745 0-6.021 4.84-6.021 7.432 0 2.12 2.193 2.079 4.494 1.994l.384-.015c.385-.014.77-.026 1.143-.026 2.746 0 4.972-2.1 4.972-4.692S24.61 0 21.864 0Zm.23 3.68c1.501 0 2.709.747 2.709 1.904S21.394 7.32 19.44 7.32c-.674 0-.908-.581-1.003-.946-.146-.874 2.157-2.693 3.658-2.693Z",
    fill: "#9245B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.687 7.542h22.626A3.687 3.687 0 0 1 30 11.229v.822a2.865 2.865 0 0 1-2.865 2.865H2.865A2.865 2.865 0 0 1 0 12.051v-.822a3.687 3.687 0 0 1 3.687-3.687Z",
    fill: "#6F40EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.53a3.708 3.708 0 0 1 3.708 3.709v5.677h-7.416V9.24A3.708 3.708 0 0 1 15 5.53Z",
    fill: "#9245B7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F34A5",
    d: "M11.292 14.916h7.416V30h-7.416z"
  }))));
};
export default SvgGiftBag;